module.exports = __webpack_public_path__ + "static/media/thermalInversion.3ecf1d84.png";